module.exports = __webpack_public_path__ + "static/media/palette.bfd3818e.scss";


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/palette.scss
// module id = 94
// module chunks = 0